import { useState, memo, useEffect } from "react"
import { parse, format, isValid } from "date-fns"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker"
import { ptBR } from "date-fns/locale"
import TextField from "@mui/material/TextField"

// Personalização do locale para começar a semana na segunda-feira
const customPtBRLocale = {
  ...ptBR,
  options: {
    ...ptBR.options,
    weekStartsOn: 1,
  },
}

// Converte string "dd/MM/yyyy" para Date
const parseDate = (date) => {
  if (!date) return null
  if (date instanceof Date && isValid(date)) return date // Se já for Date válido, mantém
  if (typeof date === "string" && date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const parsed = parse(date, "dd/MM/yyyy", new Date())
    return isValid(parsed) ? parsed : null
  }
  return null
}

// Converte Date para string "dd/MM/yyyy"
const formatDate = (date) => {
  return date && isValid(date) ? format(date, "dd/MM/yyyy") : ""
}

// Componente customizado de TextField
function CustomTextField({ onChange, error, touched, ...props }) {
  return <TextField onChange={onChange} error={error} fullWidth {...props} />
}

function DateComponent({ 
  id, 
  name, 
  value, 
  errors, 
  touched, 
  onChange, 
  defaultValue, 
  ...props 
}) {
  
  // Estado interno da data
  const [selectedDate, setSelectedDate] = useState(parseDate(value) || parseDate(defaultValue))

  // Atualiza o estado interno da data
  const handleDateChange = (date) => {
    setSelectedDate(date)    
  }

  useEffect( () => {
    onChange?.(formatDate(selectedDate))
    // eslint-disable-next-line
  }, [selectedDate])
  
  
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customPtBRLocale}>
      <DesktopDatePicker
        id={id}
        name={name}
        value={selectedDate}
        inputFormat="dd/MM/yyyy"
        slots={{ textField: CustomTextField }}
        onChange={handleDateChange}
        {...props}
      />
    </LocalizationProvider>
  )
}

export default memo(DateComponent)
